import gql from 'graphql-tag';

import conversationFragment from './conversationFragment';

export const conversationsPageFragment = gql`
  fragment conversationsPageFragment on ConversationsPage {
    dokkioClass
    total
    conversations {
      ...conversationFragment
    }
  }
  ${conversationFragment}
`;
export default conversationsPageFragment;
